import { NavItem, Testimonial, QuizQuestion, QuizResultType, QuizResult, BlogPost } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'For Physicians', path: '/physicians' },
  { label: 'Economics', path: '/economics' },
  { label: 'VBC Reality Check', path: '/reality-check' },
  { label: 'Onboarding', path: '/onboarding' },
  { label: 'Resources', path: '/resources' },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    quote: "I was drowning in HEDIS gaps. Suncoast's team physically came to my office in Miami to help close them. My Stars rating jumped from 3.5 to 4.5 in one year.",
    author: "Dr. Elena R.",
    role: "Internal Medicine",
    type: "PCP"
  },
  {
    id: '2',
    quote: "Finally, a shared savings report I can actually read. No black box. I know exactly where my surplus comes from.",
    author: "Dr. James T.",
    role: "Family Practice",
    type: "PCP"
  },
  {
    id: '3',
    quote: "The transition of care support is real. They contact my patients within 24 hours of discharge, which saves my staff hours of phone tag.",
    author: "Sarah M.",
    role: "Office Manager",
    type: "Office Manager"
  },
  {
    id: '4',
    quote: "Moving from pure FFS to value-based care felt risky until I saw their capitation truth table. It de-risked the whole process for us.",
    author: "Dr. A. Patel",
    role: "Geriatrics",
    type: "PCP"
  },
  {
    id: '5',
    quote: "We wanted to stay independent but needed MSO muscle. Suncoast gave us the infrastructure without changing our sign on the door.",
    author: "Dr. Gonzalez",
    role: "Pediatrics & Family",
    type: "PCP"
  },
  {
    id: '6',
    quote: "I've worked with three other MSOs. Suncoast is the first one that actually pays claims on time and picks up the phone.",
    author: "Maria S.",
    role: "Billing Director",
    type: "Office Manager"
  },
  {
    id: '7',
    quote: "The VBC Reality Check tool opened my eyes. I didn't realize how much admin work I was doing for free under my old plan.",
    author: "Dr. Weiss",
    role: "Internal Medicine",
    type: "PCP"
  },
  {
    id: '8',
    quote: "Financial transparency is rare in Florida. Suncoast shows us the raw data, the costs, and the split. Total trust.",
    author: "James L.",
    role: "CFO",
    type: "Office Manager"
  }
];

export const TESTIMONIALS_ES: Testimonial[] = [
  {
    id: '1',
    quote: "Me ahogaba en brechas de HEDIS. El equipo de Suncoast vino físicamente a mi oficina en Miami para ayudar a cerrarlas. Mi calificación de Estrellas saltó de 3.5 a 4.5 en un año.",
    author: "Dr. Elena R.",
    role: "Medicina Interna",
    type: "PCP"
  },
  {
    id: '2',
    quote: "Finalmente, un informe de ahorros compartidos que realmente puedo leer. Sin caja negra. Sé exactamente de dónde viene mi excedente.",
    author: "Dr. James T.",
    role: "Medicina Familiar",
    type: "PCP"
  },
  {
    id: '3',
    quote: "El apoyo en la transición de la atención es real. Contactan a mis pacientes dentro de las 24 horas del alta, lo que ahorra a mi personal horas de llamadas.",
    author: "Sarah M.",
    role: "Gerente de Oficina",
    type: "Office Manager"
  },
  {
    id: '4',
    quote: "Pasar de FFS puro a atención basada en el valor se sentía arriesgado hasta que vi su tabla de verdad de capitación. Eliminó el riesgo de todo el proceso para nosotros.",
    author: "Dr. A. Patel",
    role: "Geriatría",
    type: "PCP"
  },
  {
    id: '5',
    quote: "Queríamos mantenernos independientes pero necesitábamos el músculo de una MSO. Suncoast nos dio la infraestructura sin cambiar nuestro letrero en la puerta.",
    author: "Dr. Gonzalez",
    role: "Pediatría y Familia",
    type: "PCP"
  },
  {
    id: '6',
    quote: "He trabajado con otras tres MSO. Suncoast es la primera que realmente paga las reclamaciones a tiempo y contesta el teléfono.",
    author: "Maria S.",
    role: "Directora de Facturación",
    type: "Office Manager"
  },
  {
    id: '7',
    quote: "La herramienta de Diagnóstico VBC me abrió los ojos. No me daba cuenta de cuánto trabajo administrativo hacía gratis bajo mi plan anterior.",
    author: "Dr. Weiss",
    role: "Medicina Interna",
    type: "PCP"
  },
  {
    id: '8',
    quote: "La transparencia financiera es rara en Florida. Suncoast nos muestra los datos brutos, los costos y la división. Confianza total.",
    author: "James L.",
    role: "Director Financiero",
    type: "Office Manager"
  }
];

export const QUIZ_QUESTIONS: QuizQuestion[] = [
  {
    id: 1,
    question: "How is your practice currently compensated for Medicare Advantage patients?",
    options: [
      { label: "100% Fee-for-Service (FFS)", value: "ffs", score: { riskTolerance: 0, adminBurden: 0 } },
      { label: "FFS + small PMPM (Care Management fees)", value: "ffs_pmpm", score: { riskTolerance: 1, adminBurden: 0 } },
      { label: "Shared Savings (Upside Only)", value: "upside", score: { riskTolerance: 2, adminBurden: 1 } },
      { label: "Capitation / Full Risk", value: "risk", score: { riskTolerance: 5, adminBurden: 2 } },
      { label: "I'm not sure / It's complicated", value: "confused", score: { riskTolerance: 0, adminBurden: 5 } }
    ]
  },
  {
    id: 2,
    question: "Do you receive detailed data on your patients' hospital admissions in real-time?",
    options: [
      { label: "No, I find out when they come in for a follow-up.", value: "no", score: { infrastructure: 0 } },
      { label: "Sometimes, via fax or sporadic emails.", value: "sometimes", score: { infrastructure: 1 } },
      { label: "Yes, I have a system (or partner) for this.", value: "yes", score: { infrastructure: 5 } }
    ]
  },
  {
    id: 3,
    question: "How do you handle annual coding and HEDIS gap closure?",
    options: [
      { label: "My staff tries to call patients when we have downtime.", value: "manual", score: { adminBurden: 5 } },
      { label: "We have a dedicated person, but they are overwhelmed.", value: "dedicated", score: { adminBurden: 3 } },
      { label: "Our partner/MSO handles the outreach for us.", value: "partner", score: { adminBurden: 0, infrastructure: 3 } }
    ]
  },
  {
    id: 4,
    question: "Do you feel you are fairly compensated for the administrative work of MA plans?",
    options: [
      { label: "No, I do hours of free work.", value: "no", score: { adminBurden: 5 } },
      { label: "It's okay, but could be better.", value: "meh", score: { adminBurden: 2 } },
      { label: "Yes, the surplus checks make it worth it.", value: "yes", score: { riskTolerance: 3 } }
    ]
  },
  {
    id: 5,
    question: "How comfortable are you with the idea of 'downside risk' (paying money back if costs are high)?",
    options: [
      { label: "Absolutely not comfortable.", value: "no_risk", score: { riskTolerance: 0 } },
      { label: "Willing if the potential bonus is large enough.", value: "maybe_risk", score: { riskTolerance: 3 } },
      { label: "I already accept downside risk.", value: "yes_risk", score: { riskTolerance: 5 } }
    ]
  },
  {
    id: 6,
    question: "Does your practice have reinsurance (stop-loss) to protect against catastrophic claims?",
    options: [
      { label: "What is that?", value: "unknown", score: { riskTolerance: 0, adminBurden: 2 } },
      { label: "No, I don't think so.", value: "no", score: { riskTolerance: 1 } },
      { label: "Yes, we are covered.", value: "yes", score: { riskTolerance: 5, infrastructure: 2 } }
    ]
  },
  {
    id: 7,
    question: "How often do you receive financial reconciliation reports from your payers/partners?",
    options: [
      { label: "Never / I don't see them.", value: "never", score: { adminBurden: 5 } },
      { label: "Once a year.", value: "annually", score: { infrastructure: 1 } },
      { label: "Monthly or Quarterly.", value: "frequent", score: { infrastructure: 5 } }
    ]
  },
  {
    id: 8,
    question: "Do you share in savings from pharmacy, home health, or specialist referrals?",
    options: [
      { label: "No, just primary care services.", value: "pcp_only", score: { riskTolerance: 1 } },
      { label: "I don't know.", value: "unknown", score: { adminBurden: 3 } },
      { label: "Yes, we have full global risk participation.", value: "global", score: { riskTolerance: 5 } }
    ]
  },
  {
    id: 9,
    question: "How much time does your front desk spend on payer portals authorizing referrals?",
    options: [
      { label: "Way too much (hours per day).", value: "high", score: { adminBurden: 5 } },
      { label: "Some, but it's manageable.", value: "med", score: { adminBurden: 2 } },
      { label: "Very little / It's automated.", value: "low", score: { infrastructure: 5 } }
    ]
  },
  {
    id: 10,
    question: "What is your primary goal for the next 12 months?",
    options: [
      { label: "Stability & reducing chaos.", value: "stability", score: { riskTolerance: 0 } },
      { label: "Incremental revenue growth.", value: "growth", score: { riskTolerance: 2 } },
      { label: "Maximizing profit, ready to take risk.", value: "max", score: { riskTolerance: 5 } }
    ]
  }
];

export const QUIZ_RESULTS: Record<QuizResultType, QuizResult> = {
  [QuizResultType.FFS_WARRIOR]: {
    type: QuizResultType.FFS_WARRIOR,
    title: "The FFS Warrior",
    description: "You are working harder than you need to. You provide great care, but the fee-for-service hamster wheel isn't rewarding you for outcomes.",
    painPoints: ["Unpaid administrative time", "Revenue tied strictly to visits", "No infrastructure for population health"],
    suncoastFix: "We introduce an Upside-Only Shared Savings layer. You keep your FFS billing, but we add a bonus pool for Quality & Utilization metrics."
  },
  [QuizResultType.UPSIDE_SAVER]: {
    type: QuizResultType.UPSIDE_SAVER,
    title: "The Upside Explorer",
    description: "You've dipped your toe in Value-Based Care, but you might be leaving money on the table due to 'leakage' or missing data.",
    painPoints: ["Difficulty tracking patient admissions", "HEDIS gaps remain open", "Uncertainty about bonus checks"],
    suncoastFix: "We provide the 'Two Lanes' model. We take over the high-risk outreach and TOC, ensuring you actually HIT the targets required for your bonus."
  },
  [QuizResultType.RISK_READY]: {
    type: QuizResultType.RISK_READY,
    title: "The Capitation Captain",
    description: "You understand risk, but you need a partner who is transparent and reduces the operational overhead of managing risk.",
    painPoints: ["Reinsurance complexity", "High-cost claimants destroying pools", "Lack of actuary support"],
    suncoastFix: "Our transparent capitation model. No black boxes. You see the PMPM, the claims, and the surplus. Plus, we handle the catastrophic risk layers."
  },
  [QuizResultType.BLACK_BOX_VICTIM]: {
    type: QuizResultType.BLACK_BOX_VICTIM,
    title: "The 'Black Box' Skeptic",
    description: "You are in an arrangement where the money flow is unclear. You don't know if you're truly getting your fair share of savings.",
    painPoints: ["Confusing settlement reports", "Hidden fees", "Lack of trust in partner"],
    suncoastFix: "Total transparency. We show you the 'Capitation Truth Table'—revenue in, claims out, surplus split. No hidden admin fees."
  }
};

export const RESOURCES: BlogPost[] = [
  { id: '1', title: 'The 2024 CMS Stars Changes: What PCPs Need to Know', category: 'Compliance', readTime: '5 min' },
  { id: '2', title: 'How to Implement a 48-Hour TOC Protocol Without Hiring Staff', category: 'Operations', readTime: '3 min' },
  { id: '3', title: 'Understanding RAF Scores: Ethical Coding vs. Upcoding', category: 'Economics', readTime: '6 min' },
];

export const RESOURCES_ES: BlogPost[] = [
  { id: '1', title: 'Cambios en CMS Stars 2024: Lo que los PCP deben saber', category: 'Cumplimiento', readTime: '5 min' },
  { id: '2', title: 'Cómo implementar un protocolo TOC de 48 horas sin contratar personal', category: 'Operaciones', readTime: '3 min' },
  { id: '3', title: 'Entendiendo los puntajes RAF: Codificación ética vs. Upcoding', category: 'Economía', readTime: '6 min' },
];